import React from 'react'
import {
  StyledCard,
  StyledDepartment,
  StyledFullName,
  StyledPhone,
  StyledSeparator,
  StyleEmail,
} from './CardContact.styled'
import PropTypes from 'prop-types'
/* TODO : i18n */
const SUBJECT = 'Email from Constellium website'

const CardContact = (props) => {
  const {department, email, firstname, lastname, phone, className} = props

  return (
    <StyledCard className={className}>
      <StyledSeparator/>
      <StyledDepartment>{department}</StyledDepartment>
      <StyledFullName>{firstname + ' ' + lastname}</StyledFullName>
      {phone && <StyledPhone href={`tel:${phone}`}>{phone}</StyledPhone>}
      {email && (
        <StyleEmail href={`mailto:${email}?subject=${SUBJECT}`}>
          {email}
        </StyleEmail>
      )}
    </StyledCard>
  )
}

CardContact.propTypes = {
  department: PropTypes.string.isRequired,
  email: PropTypes.string,
  firstname: PropTypes.string.isRequired,
  lastname: PropTypes.string.isRequired,
  phone: PropTypes.string,
}

export default CardContact
